import './styles/main.scss';
import {AuthProvider} from "./context/AuthContext";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import RideDetails from "./components/RideDetails";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import RideHistory from "./components/RideHistory";
import Header from "./components/Header";
import Profile from "./components/Profile";
import Order from "./components/Order";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer/Footer";
import {ErrorModalProvider} from "./context/ErrorModalContext";
import RepeatOrder from "./components/RepeatOrder";
import {RideStatusProvider} from "./context/RideStatusContext";

function AppRoutes() {
    const location = useLocation();
    const isLogin = location.pathname === '/login';
    const isOrderPage = location.pathname === '/order';

    return (
        <div className="main-layout">
            <Header />
            {isLogin ? (
                <div className="routes-wrapper">
                    <Routes>
                        <Route path="/login" element={<Login />} />
                    </Routes>
                </div>
            ) : (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/ride/:encodedId" element={<RideDetails />} />
                    <Route path="/repeat/:encodedId" element={<RepeatOrder />} />
                    <Route
                        path="/history"
                        element={
                            <PrivateRoute>
                                <RideHistory />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <PrivateRoute>
                                <Profile />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/order"
                        element={
                            <PrivateRoute>
                                <Order />
                            </PrivateRoute>
                        }
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            )}
            {(!isOrderPage && !isLogin) && <Footer />}
        </div>
    );
}

function App() {
    useEffect(() => {
        window.onerror = function (msg, url) {
            if (url?.includes("cc.js")) return true;
        };
    }, []);

    return (
        <AuthProvider>
            <ErrorModalProvider>
                <RideStatusProvider>
                    <Router>
                        <AppRoutes />
                    </Router>
                </RideStatusProvider>
            </ErrorModalProvider>
        </AuthProvider>
    );
}

export default App;
